<template>
  <div data-dusk="package">
    <dd-header-card
        @click="onPackageClick()"
        :wide-content="false"
        :header="policyPackage.name">

      <template v-slot:icon>
        <div class="flex-row align-items-center gap-sm">
          <PackageExpiredIcon v-if="policyPackage.is_expired"/>
          <ArchiveIcon v-else class="icon-size-lg"/>
          <img v-if="policyPackage.agency_logo"
               class="logo"
               :src="policyPackage.agency_logo" alt="Package logo">
        </div>
      </template>
      <template v-slot:subtitle>
          <span class="premium">
            Premie: {{ policyPackage.total_term_amount }} p/m
          </span>
      </template>
      <template v-slot:action>
        <div class="flex-row gap-sm">
          <dd-button
            v-if="policyPackage.agency"
            :small="true"
            icon="mdi mdi-phone"
            :outline="true"
          >
            <AgencyContactDetailsComponent
              :id="policyPackage.agency.data.id"
            />
          </dd-button>
          <dd-button :href="addPolicy()" class="square-button" type="success">
            <template v-slot:icon>
              <PlusIcon class="icon-size-lg"> </PlusIcon>
            </template>
          </dd-button>
        </div>
      </template>
      <dd-main-table
          v-if="policyPackage.policies.data.length > 0"
          :rounded="true"
          :has-select="false"
          :headers="packageTableHeaders"
          :rows="policyPackage.policies.data"
      ></dd-main-table>

      <p v-else-if="policiesFilterActive" class="nothing-found">
        Dit pakket heeft geen polissen die aan het huidige filter voldoen.
      </p>
      <p v-else class="nothing-found">
        Dit pakket heeft nog geen polissen.
      </p>
    </dd-header-card>
  </div>
</template>

<script>
import PhoneButton from "./call/PhoneButton.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import PackageExpiredIcon from "./PackageExpiredIcon.vue";

export default {
  name: "PackageComponent",
  components: {
    PackageExpiredIcon,
    PhoneButton,
  },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
    policyPackage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      meHasLoaded: false,
    }
  },
  created() {
    if (this.me) {
      this.meHasLoaded = true;
      this.getExtensions();
    }
    else {
      this.getMe();
    }
  },
  watch: {
    me(me) {
      if (this.extensions.length > 0 || this.meHasLoaded) return;
      if (me) this.meHasLoaded = true;
      this.getExtensions();
    }
  },
  methods: {
    onPackageClick() {
      this.navigator.navigatePath(this.viewPackage());
    },
    addPolicy() {
      return this.route('vue.insurance.policy.create', {
        customer: this.customerId,
        package: this.policyPackage.id,
      });
    },
    viewPackage() {
      return this.route('vue.insurance.package', {
        customer: this.customerId,
        package: this.policyPackage.id,
      })
    },
    ...mapActions({
      getMe: 'getMe',
      getExtensions: 'getExtensions',
    })
  },
  computed: {
    ...mapGetters('$_policy_page', {
      policyTableHeaders: 'policyTableHeaders',
      policiesFilterActive: 'policiesFilterActive',
    }),
    ...mapState({
      me: 'me',
      extensions: 'extensions',
      activeExtension: 'activeExtension',
    }),
    packageExpired() {
      return this.policyPackage.expired;
    },
    packageTableHeaders(){
      return this.policyTableHeaders.map(header => {
        if (header.key === 'agency'){
          return {
            key: "ignore_key",
            title: "",
            width: "140px"
          };
        }
        return header;
      });
    }
  }
};
</script>

<style scoped>

</style>
